<template>
  <a title="Delete" @click="openModal" href="javascript:void(0)"><i class="text-danger fa fa-times"></i></a>
</template>

<script>
import eventBus from '../../event-bus';

export default {
  props: {
    challenge: {
      type: Object
    }
  },
  methods: {
    openModal() {
      eventBus.$emit('deleteChallengeModalOpened', this.challenge);
    }
  }
}
</script>

